import { ValueObject } from '@/engine/core/valueObject';
import type { IValue } from '@/engine/DataFlow/Graph';
import type { ValueConstructor } from '@/engine/DataFlow/DataFlow';
import type { IDataModelValueConfigProps } from './interfaces';

/**
 * Represents a data model value used in report configuration.
 * @template T - The type of the value.
 */
export class ReportConfigDataModelValue<T extends IValue = IValue> extends ValueObject<IDataModelValueConfigProps<T>> {
  public constructor(props: IDataModelValueConfigProps<T>) {
    super(props);
  }

  /**
   * Gets the descriptor of the data model value.
   */
  public get descriptor(): string {
    return this.props.descriptor;
  }

  /**
   * Gets the phase of the data model value.
   */
  public get phase(): string | undefined {
    return this.props.phase;
  }

  /**
   * Gets the path of the data model value.
   */
  public get path(): string {
    return this.props.path;
  }

  /**
   * Gets the data type constructor of the data model value.
   */
  public get dataType(): ValueConstructor<T> {
    return this.props.dataType;
  }
}
